import React, { createContext, useContext, useState, useEffect } from "react";
import en from "../resources/lockit/en";
import pl from "../resources/lockit/pl";
import de from "../resources/lockit/de";
import es from "../resources/lockit/es";

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  const [language, setLanguage] = useState("pl"); 
  const translations = { en, pl, de, es };

  const switchLanguage = (lang) => setLanguage(lang);

  return (
    <TranslationContext.Provider value={{ t: translations[language], switchLanguage, language }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);